<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>

                

                
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Editar Cardapio</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>


                            <template>
                                <div>
                                    <v-card class="elevation-1">
                                        <v-layout row wrap>
                                            <v-expansion-panel
                                                expand
                                                v-model="panels"
                                            >
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Segunda-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor name="segCafeManha" label="Café da manhã" v-model="segCafeManha"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Terça-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>

                                                            <vue-editor name="terCafeManha" label="Café da manhã" v-model="terCafeManha"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Quarta-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor name="quaCafeManha" label="Café da manhã" v-model="quaCafeManha"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Quinta-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor name="quiCafeManha" label="Café da manhã" v-model="quiCafeManha"></vue-editor>
                                                            
                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Sexta-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor name="sexCafeManha" label="Café da manhã" v-model="sexCafeManha"></vue-editor>
                                                            
                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Sábado
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor name="sabCafeManha" label="Café da manhã" v-model="sabCafeManha"></vue-editor>
                                                            
                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Domingo
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor name="domCafeManha" label="Café da manhã" v-model="domCafeManha"></vue-editor>
                                                            
                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>    
                                        </v-layout>       
                                    </v-card>
                                </div>
                            </template><br />
                            <v-text-field name="observacao" label="Observação" type="text"
                                                                        v-model="observacao" required>
                                                            </v-text-field>

                            
                            
                            


                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-switch
                                        v-model="push"
                                        :label="`Push`"
                                    ></v-switch>
                                    <label>Se o push estiver habilitado será enviado uma notificação para todos usuários da escola.</label>
                                </v-flex>
                            </v-layout>

                            <v-text-field v-if="push == true" browser-autocomplete="new-texto-push" name="textoPush" label="Digite o texto do push" type="text"
                                          v-model="textoPush">
                            </v-text-field>

                            
                            
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="atualizarCardapio" data-cy="joinSubmitBtn">Atualizar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties } from '@/global.js'
import { userInfo } from 'os';

import axios from 'axios'
import VueAxios from 'vue-axios'

import { VueEditor } from "vue2-editor"; // https://www.vuetoolbox.com/projects/vue2-editor

//Vue.use(VueAxios, axios)

export default {
    name: 'Editar-Cardapio',
    directives: {mask},
    components: {
        VueEditor
    },
    
    data: vm => ({
        valid: false,
        texto: null,
        link: null,
        dialog: false,
        loading: false,
        slug: null,
        statusUpload: true,
        tituloModal: "Cardapio atualizado com sucesso!",
        preview: false,
        pushIDs: null,
        push: false,
        textoPush: null,
        urlImg: null,

        segCafeManha: null,
        segAlmoco: null,
        segCafeTarde: null,
        segJanta: null,
        terCafeManha: null,
        terAlmoco: null,
        terCafeTarde: null,
        terJanta: null,
        quaCafeManha: null,
        quaAlmoco: null,
        quaCafeTarde: null,
        quaJanta: null,
        quiCafeManha: null,
        quiAlmoco: null,
        quiCafeTarde: null,
        quiJanta: null,
        sexCafeManha: null,
        sexAlmoco: null,
        sexCafeTarde: null,
        sexJanta: null,
        sabCafeManha: null,
        sabAlmoco: null,
        sabCafeTarde: null,
        sabJanta: null,
        domCafeManha: null,
        domAlmoco: null,
        domCafeTarde: null,
        domJanta: null,
        observacao: null,

        panels: [false, false, false, false, false, false, false],

        content: "<h1>Some initial content</h1>"
        
    }),
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        atualizarCardapio(){

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        //slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "editar",
                        categoria: "cardapio",
                        pontos: 5
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }

            var that = this;
            if(userProperties.escolaID != null){
                this.loading = true

                db.collection('cardapio').where("escolaID", "==", userProperties.escolaID)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        console.log(doc.id, " => ", doc.data());
                        // Build doc ref from doc.id
                        db.collection('cardapio').doc(doc.id).update({                        
                            segCafeManha: this.segCafeManha,
                            //segAlmoco: this.segAlmoco,
                            //segCafeTarde: this.segCafeTarde,
                            //segJanta: this.segJanta,
                            terCafeManha: this.terCafeManha,
                            //terAlmoco: this.terAlmoco,
                            //terCafeTarde: this.terCafeTarde,
                            //terJanta: this.terJanta,
                            quaCafeManha: this.quaCafeManha,
                            //quaAlmoco: this.quaAlmoco,
                            //quaCafeTarde: this.quaCafeTarde,
                            //quaJanta: this.quaJanta,
                            quiCafeManha: this.quiCafeManha,
                            //quiAlmoco: this.quiAlmoco,
                            //quiCafeTarde: this.quiCafeTarde,
                            //quiJanta: this.quiJanta,
                            sexCafeManha: this.sexCafeManha,
                            //sexAlmoco: this.sexAlmoco,
                            //sexCafeTarde: this.sexCafeTarde,
                            //sexJanta: this.sexJanta,
                            sabCafeManha: this.sabCafeManha,
                            //sabAlmoco: this.sabAlmoco,
                            //sabCafeTarde: this.sabCafeTarde,
                            //sabJanta: this.sabJanta,
                            domCafeManha: this.domCafeManha,
                            //domAlmoco: this.domAlmoco,
                            //domCafeTarde: this.domCafeTarde,
                            //domJanta: this.domJanta,
                            observacao: this.observacao,

                            push: this.push,
                            textoPush: this.textoPush,
                        }).then(docRef => {
                            
                            if(this.push == true){
                                function loop(item, index) {
                                        var postData = {
                                        "notification": {        
                                            "title": "Atualização do cardápio!",
                                            "body": that.textoPush,
                                            "click_action": "https://inclass.app",
                                            "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                            "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                            //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                            "sound": "default"
                                        },    
                                        //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                        "to": item
                                    }

                                    let axiosConfig = {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                        }
                                    };

                                    axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                    .then((res) => {
                                        console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                    })
                                    .catch((err) => {
                                        console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                        alert("Erro no envio de push.")
                                    })
                                }

                                this.pushIDs.forEach(loop);
                            }

                            console.log('Document written with ID: ', docRef.id);
                            //this.$router.push(`/${slug}/success`)
                            this.loading = false
                            this.dialog = true
                            
                        })
                        .catch(function (error) {
                            that.loading = false
                            console.log('Error adding document: ', error);
                            console.log("Erro na atualização dos dados. Tente novamente mais tarde!")
                        })
                        this.loading = false,
                        this.dialog = true

                    });
                })

                
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
            
        },
        closeModal(){
            this.$router.push(`/display-cardapio`);
        },        
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        
        
    },
    mounted() {
        const slug = this.generateUUID()
        this.slug = slug;

        // se perfil não for escola ou administrador
        if(userProperties.perfil == 1 || userProperties.perfil == 5 || userProperties.perfil == 6 || userProperties.perfil == 7){
            alert("Acesso negado!");
            this.$router.push(`/?redirect=`+window.location.pathname)
        }

        db.collection('cardapio').where("escolaID", "==", this.$route.query.escolaID)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());               
                let customObj = doc.data()
                this.texto = customObj.texto,
                this.link = customObj.link,
                this.extensao = customObj.extensao,
                this.dateStart = customObj.dateStart,
                this.dateEnd = customObj.dateEnd,
                this.exibicaoID = customObj.exibicaoID,
                this.exibicaoName = customObj.exibicaoName,
                this.preview = customObj.preview,

                this.segCafeManha = customObj.segCafeManha,
                this.segAlmoco = customObj.segAlmoco,
                this.segCafeTarde = customObj.segCafeTarde,
                this.segJanta = customObj.segJanta,
                this.terCafeManha = customObj.terCafeManha,
                this.terAlmoco = customObj.terAlmoco,
                this.terCafeTarde = customObj.terCafeTarde,
                this.terJanta = customObj.terJanta,
                this.quaCafeManha = customObj.quaCafeManha,
                this.quaAlmoco = customObj.quaAlmoco,
                this.quaCafeTarde = customObj.quaCafeTarde,
                this.quaJanta = customObj.quaJanta,
                this.quiCafeManha = customObj.quiCafeManha,
                this.quiAlmoco = customObj.quiAlmoco,
                this.quiCafeTarde = customObj.quiCafeTarde,
                this.quiJanta = customObj.quiJanta,
                this.sexCafeManha = customObj.sexCafeManha,
                this.sexAlmoco = customObj.sexAlmoco,
                this.sexCafeTarde = customObj.sexCafeTarde,
                this.sexJanta = customObj.sexJanta,
                this.sabCafeManha = customObj.sabCafeManha,
                this.sabAlmoco = customObj.sabAlmoco,
                this.sabCafeTarde = customObj.sabCafeTarde,
                this.sabJanta = customObj.sabJanta,
                this.domCafeManha = customObj.domCafeManha,
                this.domAlmoco = customObj.domAlmoco,
                this.domCafeTarde = customObj.domCafeTarde,
                this.domJanta = customObj.domJanta,
                this.observacao = customObj.observacao,

                this.push = customObj.push,
                this.textoPush = customObj.textoPush
            });

            
            this.loading = false;

        });
        
        // Pega todos os token FCM da escola para enviar o push
        var tokensFMC = [];
        db.collection('usuarios').where("escolaID", "==", userProperties.escolaID)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());               
                let customObj = doc.data()
                if(customObj.tokenFMC != undefined && customObj.tokenFMC != "")
                    tokensFMC.push(customObj.tokenFMC)
            });

            //tokensFMC = tokensFMC.substring(0, tokensFMC.length -1);
            this.pushIDs = tokensFMC;

            this.loading = false;

        });
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }
    
    .v-expansion-panel .v-card.v-sheet.theme--light{
        background: #f7f7f7 !important
    }

    .container{
        padding: 0 !important
    }

    #quill-container{
        height: auto !important;
    }
</style>
